































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { apiMaterialDelete, apiMaterialStatus } from '@/api/material'

@Component
export default class MaterialPane extends Vue {
    @Prop({ type: Array, default: () => [] }) value!: any[]
    @Prop({ type: Object, required: true }) pager!: any
    @Prop({ type: Array, default: () => [] }) categoryList!: any[]
    @Prop({ type: Array, default: () => [] }) warehouseList!: any[]

    selectedRows: any[] = []

    get tableData () {
      return this.value
    }

    set tableData (val) {
      this.$emit('input', val)
    }

    handleSelectionChange (val: any[]) {
      this.selectedRows = val
    }

    handleAdd () {
      this.$router.push('/material/add')
    }

    handleEdit (row: any) {
      this.$router.push({ path: '/material/edit', query: { id: row.id } })
    }

    handleView (row: any) {
      this.$router.push({ path: '/material/detail', query: { id: row.id } })
    }

    handleCommand (command: string, row: any) {
      switch (command) {
        case 'delete':
          this.handleDelete(row)
          break
        case 'disable':
          this.handleStatus(row, 2)
          break
        case 'enable':
          this.handleStatus(row, 1)
          break
      }
    }

    handleDelete (row: any) {
      this.$confirm('确定要删除该物料吗？', '提示', {
        type: 'warning'
      }).then(() => {
        apiMaterialDelete({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.$emit('refresh')
        })
      })
    }

    handleStatus (row: any, status: number) {
      const action = status === 1 ? '启用' : '停用'
      this.$confirm(`确定要${action}该物料吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        apiMaterialStatus({ id: row.id, status }).then(() => {
          this.$message.success(`${action}成功`)
          this.$emit('refresh')
        })
      })
    }

    handleSizeChange (size: number) {
      this.pager.size = size
      this.$emit('refresh')
    }

    handleCurrentChange (page: number) {
      this.pager.page = page
      this.$emit('refresh')
    }

    formatCurrency (value: number): string {
      if (!value) {
        return '￥0.00'
      }
      return '￥' + Number(value).toFixed(2)
    }

    getMaterialStatusText (status: number): string {
      const statusMap = ['', '正常', '停用', '淘汰']
      return statusMap[status] || '未知'
    }

    getMaterialStatusTagType (status: number): string {
      const typeMap = ['', 'success', 'info', 'warning']
      return typeMap[status] || ''
    }

    getInventoryStatusText (row: any): string {
      if (row.is_expired) {
        return '已过期'
      }
      if (row.is_warning) {
        switch (row.warning_type) {
          case 1: return '库存不足'
          case 2: return '库存积压'
          case 3: return '即将过期'
        }
      }
      return '正常'
    }

    getInventoryStatusTagType (row: any): string {
      if (row.is_expired) {
        return 'danger'
      }
      if (row.is_warning) {
        switch (row.warning_type) {
          case 1: return 'warning'
          case 2: return 'info'
          case 3: return 'danger'
        }
      }
      return 'success'
    }
}
